import { memo, useState } from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext";
import Button from "../../../../Elements/Button/Button";
import Image from "../../../../Elements/Image/Image";
import adjustUrlToEnv from "./helpers/adjustUrlToEnv";
import useTransaction from "../../hooks/useTransaction";
import SectionTitle from "../SectionTitle";
import { PurchaseStepE } from "../../models/enums";
import LoadingImageElement from "../../../../Elements/LoadingContainerElement/LoadingImageElement";
import useCreditCard from "../../hooks/useCreditCard";
import useShowPayPalButton from "./hooks/useShowPayPalButton";

import styles from "./styles.module.scss";

interface NewCreditCardDataSectionI {
  isFailed?: boolean;
  t?: string; // Transaction id
  token?: number; // Credit card token
}

const IFRAME_HEIGHT_PX = 500;

const NewCreditCardDataSection = memo((props: NewCreditCardDataSectionI) => {
  const { isFailed, t } = props;
  const { newCreditCardIframeUrl, retrySubmitCheckout } = useTransaction();
  const { getTextByKey } = useContent();
  const [loadingButton, setLoadingButton] = useState("");
  const { isPurchaseFailed } = useCreditCard();
  const showPayPalButton = useShowPayPalButton();

  const handleRetry = async (paymentMethod: "creditcard" | "paypal") => {
    setLoadingButton(paymentMethod);
    await retrySubmitCheckout({
      typeOfPurchase: paymentMethod,
      t: t!,
    });
    setLoadingButton("");
  };

  return (
    <div className={styles.purchaseIframeContainer}>
      {<SectionTitle
        titleTextKey={
          !isFailed
            ? "purchase-payment-check-out"
            : "purchase-payment-check-out-failed"
        }
        step={PurchaseStepE.THIRD_PAYMENT_STEP}
      />}
      {!isPurchaseFailed && !props.isFailed && newCreditCardIframeUrl ? (
        <iframe
          title="JumboMail Payment"
          height={IFRAME_HEIGHT_PX}
          width="100%"
          id="iframe-payment"
          src={adjustUrlToEnv(newCreditCardIframeUrl)}
          frameBorder="0"
          sandbox="allow-top-navigation allow-scripts allow-forms allow-same-origin allow-cors-origin allow-popups allow-popups-to-escape-sandbox"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : isPurchaseFailed || props.isFailed ? (
        <div className={styles.purchaseFailedIframe}>
          <Button onClick={() => handleRetry("creditcard")}>
            {loadingButton === "creditcard" ? (
              <LoadingImageElement />
            ) : (
              getTextByKey("try-again")
            )}
          </Button>
          {showPayPalButton ? (
            <div className={styles.tryPaypal}>
              <p className={styles.tryPaypalText}>
                {getTextByKey("purchase-payment-try-paypal")}
              </p>
              <Image
                className={`${loadingButton ? "loading-paypal" : ""}`}
                onClick={() => handleRetry("paypal")}
                name={
                  loadingButton === "paypal"
                    ? "preloader"
                    : "purchases/paypal-checkout-button"
                }
                ext={loadingButton === "paypal" ? "gif" : "png"}
              />
            </div>
          ) : null}
        </div>
      ) : null}
      {!isPurchaseFailed && !props.isFailed && !newCreditCardIframeUrl && (
        <LoadingImageElement className={styles.loader} />
      )}
    </div>
  );
});

export default NewCreditCardDataSection;
